"use strict";

/* Controllers */

_BannerFlowApp.controller(
    "MoveToDialogController",
    function ListController($controller, $scope, $rootScope, Feed, LandingPage) {
        $scope.urlParams = {
            foldersOnly: true,
            folderId: $scope.ngDialogData.folderId || null,
            preventUrlUpdate: true
        };

        $controller("ListController", { $scope: $scope });

        $scope.listModel.excludeItems = $scope.ngDialogData.items;

        $scope.moveToModel = {
            items: $scope.ngDialogData.items,
            loading: false,
            typeName: ""
        };

        $scope.gotoRoot = function () {
            $scope.urlParams.folderId = null;
            $scope.moveToModel.currentFolder = null;
            $scope.reloadTable();
        };

        $scope.gotoFolder = function (folder) {
            $scope.urlParams.folderId = folder;
            $scope.moveToModel.currentFolder = folder;

            $scope.reloadTable();
        };

        $scope.move = function () {
            $scope.moveToModel.loading = true;
            $scope.moveItems(
                $scope.moveToModel.items,
                $scope.moveToModel.currentFolder ? $scope.moveToModel.currentFolder : null,
                function () {
                    $scope.moveToModel.loading = false;
                    $scope.closeThisDialog("reload");
                }
            );
        };

        if ($scope.ngDialogData.type === $rootScope.OBJECT_TYPE_FEED) {
            $scope.listModel.resource = Feed;
            $scope.moveToModel.type = {
                name: "Feeds"
            };
        } else if ($scope.ngDialogData.type === $rootScope.OBJECT_TYPE_LANDINGPAGE) {
            $scope.listModel.resource = LandingPage;
            $scope.moveToModel.type = {
                name: "Landing pages"
            };
        }
    }
);
